import { ReactElement } from 'react';

import { Nullable } from '~globals/types/commons';
import DataTable from '~components/DataTable';

import { useIntegrationsSectionContext } from '../Context';

import { useIntegrationsSectionDataTableColumns } from './useColumns';

const IntegrationsSectionDataTable = (): Nullable<ReactElement> => {
  const {
    data: { list: data, loading: loadingData },
    hiddenTableEmpty,
  } = useIntegrationsSectionContext();

  const columns = useIntegrationsSectionDataTableColumns();

  if (hiddenTableEmpty && data.length === 0) return null;

  return (
    <DataTable
      loading={loadingData}
      data={data}
      columns={columns}
      keyField="companyIntegrationId"
    />
  );
};

export default IntegrationsSectionDataTable;
